import {PointModel} from "@/shared/model";
import {CoordinateModel, DEFAULT_COORDINATE} from "@/shared/model/CoordinateModel";
import * as z from "zod";

const schema = z.object({
	centerCoordinate: z.nullable(CoordinateModel.model),
	contents: z.array(PointModel.model)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantPointResModel = {schema, model};
export type ITaxAccountantPointResModel = z.infer<typeof TaxAccountantPointResModel.model>;
export const DEFAULT_POINT_RES: ITaxAccountantPointResModel = {
	centerCoordinate: DEFAULT_COORDINATE,
	contents: []
};
